import { caaMetricsRepositoryAdapter } from '../../infra/repositories/caaMetricsRepositoryAdapter'

export function GetOperationalCAAMetricsPatientYearCase(
  repository: ReturnType<typeof caaMetricsRepositoryAdapter>
) {
  return async (params: { personaName?: string; year: number }) => {
    return await repository.getOperationalCAAMetricsPatientYear(params)
  }
}
